<template>
 <div class="c-bordered-content">
    <slot></slot>
 </div>
</template>

<script>
export default {}
</script>


// WEBPACK FOOTER //
// src/components/components/reportAProblem/_contact-us-rap/_vue/BorderedContent.vue